import React from 'react';
import { Box, Card, Typography, makeStyles } from 'vendor/material';
import { AwsCredentialsState } from '../../../api/awsCredentialsStatus';
import LoadingIcon from '../assets/LoadingIcon.gif';

const useStyles = makeStyles((theme) => ({
  card: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  standardCopyBold: {
    color: theme.palette.NEUTRAL700,
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(16),
    marginBottom: theme.spacing(1),
  },
  standardCopy: {
    color: theme.palette.NEUTRAL700,
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
  },
  loadingIcon: {
    width: '50px',
    height: '50px',
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
}));

interface Props {
  isVisible: boolean;
  credentials: AwsCredentialsState;
}

const AwsConnectionStatusCard: React.FC<Props> = ({
  isVisible,
  credentials,
}) => {
  const classes = useStyles();

  if (!isVisible) {
    return null;
  }

  return (
    <Card className={classes.card}>
      <Box display="flex" alignItems="center" p={2}>
        <img src={LoadingIcon} alt="Loading" className={classes.loadingIcon} />
        <Box>
          <Typography className={classes.standardCopyBold}>
            Tackle is connecting to AWS ...
          </Typography>
          <Typography className={classes.standardCopy}>
            If this page does not update in the next few minutes, please
            refresh.
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default AwsConnectionStatusCard;
